import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from "@mui/material";
import { settingsSections } from "./settingsConfig";

const SettingsSidebar = ({ activeSection, activeItem }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box sx={{ width: 260, flexShrink: 0 }}>
      {settingsSections.map((section) => (
        <Box key={section.key} sx={{ mb: 3 }}>
          <Typography
            variant="body2"
            sx={{
              display: "block",
              px: 2,
              mb: 1,
              fontWeight: 700,
              letterSpacing: 0.5,
              textTransform: "uppercase",
              color: theme.palette.text.secondary,
            }}
          >
            {section.label}
          </Typography>
          <List dense disablePadding>
            {section.items.map((item) => {
              const isActive =
                section.key === activeSection && item.key === activeItem;
              const Icon = item.icon;
              return (
                <ListItemButton
                  key={item.key}
                  selected={isActive}
                  onClick={() => navigate(`/settings/${section.key}/${item.key}`)}
                  sx={{
                    borderRadius: 1,
                    mb: 0.5,
                    color: theme.palette.text.secondary,
                    "&.Mui-selected": {
                      bgcolor: "action.selected",
                      color: "primary.main",
                      "&:hover": { bgcolor: "action.selected" },
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 32,
                      zoom: 0.85,
                      color: isActive ? "primary.main" : "text.secondary",
                    }}
                  >
                    <Icon style={{ fontSize: "16px" }} />
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{
                      fontSize: "0.9rem",
                      fontWeight: isActive ? 600 : 500,
                    }}
                  >
                    {item.label}
                  </ListItemText>
                </ListItemButton>
              );
            })}
          </List>
        </Box>
      ))}
    </Box>
  );
};

export default SettingsSidebar;
